<h1 class="cg-h1">{{ 'am.pageTitle' | translate }}</h1>

<cigna-process-steps
  class="cg-hide-for-print"
  [steps]="steps$ | async"
  [activeStep]="4"
  [hiddenSteps]="hiddenSteps$ | async"
></cigna-process-steps>

<h3 class="cg-h3">{{ 'am.confirm.header' | translate }}</h3>
<p class="cg-margin-top-none cg-margin-bottom-xl">
  {{ 'am.confirm.subHeader' | translate }}
</p>

<div class="cg-margin-bottom-lg">
  <cigna-table-review-confirm
    [users]="selectedUsers$ | async"
    [shouldShowPrefLob]="true"
    [userType]="selectedUserType$ | async"
    tableView="lob-pref"
  >
  </cigna-table-review-confirm>
</div>

<cigna-page-step-navigation
  [showPrevious]="false"
  [nextEnabled]="(impersonator$ | async) === false"
  nextButtonLabel="Continue"
  [showCancel]="false"
  [submitting]="submitting$ | async"
  (next)="nextScreen()"
>
</cigna-page-step-navigation>
